import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Typography } from '@mui/material';
import BrowserUpdatedIcon from '@mui/icons-material/BrowserUpdated';

import { ISaveFile } from './interfaces';

const SaveFile = ({ downloadUrl }: ISaveFile) => {
  const { t: translate } = useTranslation();
  const handleSaveFile = () => {
    window.open(downloadUrl, '_blank');
  };

  return (
    <Button onClick={handleSaveFile}>
      <BrowserUpdatedIcon />
      <Typography>{translate('poiPreview.saveFile')}</Typography>
    </Button>
  );
};

export default SaveFile;
